var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fileList" },
    [
      _c(
        "el-table",
        {
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.fromList },
        },
        [
          _c("el-table-column", {
            attrs: { width: "40" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "file-item-checkbox" },
                      [
                        _c("el-checkbox", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !scope.row.hasOwnProperty("percentage"),
                              expression:
                                "!scope.row.hasOwnProperty('percentage')",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              return _vm.checkboxChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.checkbox,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "checkbox", $$v)
                            },
                            expression: "scope.row.checkbox",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "66" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "file-item-img" }, [
                      _c("img", {
                        staticClass: "file-item-img-url",
                        attrs: {
                          src: scope.row.thumbnailStr,
                          alt: scope.row.old_filename,
                        },
                      }),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "old_filename",
              label: this.$t("name"),
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "file-item-filename",
                        class: [_vm.getIsGcode(scope.row) && "cursor"],
                        attrs: { title: scope.row.old_filename },
                        on: {
                          click: function ($event) {
                            return _vm.openViewInfo(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.old_filename))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "file_extension",
              label: this.$t("type"),
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.file_extension
                            ? `.${scope.row.file_extension}`
                            : scope.row.file_extension
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "size", label: this.$t("size"), sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.sizeStr))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "create_time",
              label: this.$t("upload_date"),
              sortable: "",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row?.percentage != 0,
                            expression: "scope.row?.percentage != 0",
                          },
                        ],
                      },
                      [_c("span", [_vm._v(_vm._s(scope.row.timeStr))])]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row?.percentage == 0,
                            expression: "scope.row?.percentage == 0",
                          },
                        ],
                        staticClass: "progress",
                      },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: scope.row.percent || 0,
                            "show-text": false,
                          },
                        }),
                        _c("span", { staticClass: "progress-text" }, [
                          _vm._v(
                            _vm._s(
                              `${_vm.$t("uploading")}（${
                                scope.row.percent || 0
                              }%）`
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !scope.row.hasOwnProperty("percentage"),
                            expression:
                              "!scope.row.hasOwnProperty('percentage')",
                          },
                        ],
                        staticClass: "file-state",
                      },
                      [
                        _vm._l(_vm.option.fileState, function (item, index) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.getHidden(item.label, scope.row),
                                  expression:
                                    "getHidden(item.label, scope.row)",
                                },
                              ],
                              key: index,
                              class: `${item.value}_icon`,
                              on: {
                                click: function ($event) {
                                  return _vm.handlerClick(item.value, scope.row)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require(`@/assets/imgs/cloudSpace/${item.icon}.webp`),
                                  alt: "",
                                },
                              }),
                            ]
                          )
                        }),
                        _c("fileEditDropdown", {
                          attrs: { item: scope.row, type: "list" },
                          on: {
                            fileChange: _vm.fileChange,
                            openViewInfo: _vm.openViewInfo,
                            pushUserMd5: _vm.pushUserMd5,
                            cancelDownload: _vm.cancelDownload,
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.percentage == 0,
                            expression: "scope.row.percentage == 0",
                          },
                        ],
                        staticClass: "upload-icon",
                      },
                      [
                        scope.row.status !== "fail"
                          ? _c("div", {
                              staticClass: "uploading",
                              on: {
                                click: function ($event) {
                                  return _vm.handlerDel(scope.row)
                                },
                              },
                            })
                          : _c("div", {
                              staticClass: "uploadError",
                              on: {
                                click: function ($event) {
                                  return _vm.handleReload(scope.row)
                                },
                              },
                            }),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }